// extracted by css-extract-rspack-plugin
export default {"root":"root-fOqBzQ","root_active":"root_active-gFShPU","rootActive":"root_active-gFShPU","icon":"icon-qRdqJQ","title":"title-aQqzB9","iconWrapper":"iconWrapper-v7UScZ"};